import { DqlQuery, Query } from '../field';

export class CustomStatistics {

  readonly id: Query.NumberField;
  readonly name: Query.StringField;
  readonly externalId: Query.StringField;

  constructor(prefix?: string) {
    prefix = prefix ? prefix : '';
    this.id = new DqlQuery.NumberField(prefix + 'id');
    this.name = new DqlQuery.StringField(prefix + 'name');
    this.externalId = new DqlQuery.StringField(prefix + 'external_id');
  }

}
